  import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { ToolServices } from '../services/tools.service';
import { TOOLS_STORE_ACTIONS, TOOLS_STORE_MUTATIONS, _TOOLS_STORE } from '../values/tools.values';
import Vue from 'vue';

export const TOOLS_STORE = _TOOLS_STORE;

@Module({ namespaced: true })
export class ToolsStore extends VuexModule {
  
  /* State */
  public institutionInfo: any[] = [];
  public schoolDA: any = null;
  public countries: any[] = [];
  public recentActivitiesInfo: any[] = [];

  /* Mutations */
  @Mutation
  public setInstitutionInfo(data: any) {
    this.institutionInfo = data;
  }

  @Mutation
  public setInstitutionSDA(data: any) {
    this.schoolDA = data;
  }

  @Mutation
  public setCountries(data: any) {
    this.countries = data;
  }

  @Mutation
  public setRecentActivities(data: any) {
    let content = data.content
    let page = data.number
    let totalPages = data.totalPages;
    this.recentActivitiesInfo = [...this.recentActivitiesInfo, {page, content, totalPages}]
  }

  @Mutation
  public cleanRecentActivities() {
    this.recentActivitiesInfo = [];
  }

  /* Actions */
  @Action
  public async getInstitutionInfo() {
    try {
      const data: any = await ToolServices.getInstitutionData();
      this.context.commit(TOOLS_STORE_MUTATIONS.SET_INSTITUTION_INFO, data);
    } catch(err) {
      return true;
    }
  }

  @Action
  public async getInstitutionSDA(id: number) {
    let data: any = await ToolServices.getInstitutionSDA(id)
    this.context.commit( TOOLS_STORE_MUTATIONS.SET_INSTITUTION_SDA, data);
  }

  @Action
  public async updateInstitutionInfo(data: any) {
    let institutionInfo = {
      name: data.name,
      webSite: data.webSite,
      phone: data.phoneNumber,
      phoneExt: data.ext,
      addr1: data.institutionAdress,
      addr2: data.institutionAdress2,
      addr3: data.institutionAdress3,
      zipcode: data.zipCode,
      state: data.state,
      city: data.city,
      countryCode: data.countryCode,
      /* Not modifiable by the form */
      organizationId: data.organizationId,
      typeId: data.typeId,
      status: data.status,
      ein: data.ein,
      registeredEnterprise: data.registeredEnterprise,
      organizationParentId: data.organizationParentId,
      categoryId: []
    }
    if(data.categories) {
      data.categories.forEach((c: any) => {
        institutionInfo.categoryId.push(c.id)
      });
    }     
    await ToolServices.updateInstitutionInfo(institutionInfo);
    await this.context.dispatch(TOOLS_STORE_ACTIONS.GET_INSTITUTION_INFO);
  }

  @Action
  public async getCountries() {
    let data: any = await ToolServices.getCountries()
    this.context.commit(TOOLS_STORE_MUTATIONS.SET_COUNTRIES, data);
  }

  @Action
  public getRecentActivities({page=0,pageSize=10}:{page:number,pageSize:number}) {
    return new Promise((resolve,reject) => {
        Vue.prototype.$Auth.Services.getRecentActivities(page, pageSize).then((res:any) => {
        this.context.commit(TOOLS_STORE_MUTATIONS.SET_RECENT_ACTIVITIES, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.institutionInfo = [];
    this.schoolDA = null;
    this.countries = [];
    this.recentActivitiesInfo = [];
  }
}